import axiosInstanceNew from "lib/axiosinstanceNew";
import axiosInstance from "../lib/axiosInstance";

const Parentmodel = class {
  constructor() {
    this.baseUrl = "/adminapi/parent/";
  }


  async Parentlist(status, query = []) {
    return (await axiosInstanceNew.get(`parents${status}&${new URLSearchParams(query)}`)).data;
  }
 // async Parentlist(query = []) {
 //   return (await axiosInstance.get(`${this.baseUrl}?${new URLSearchParams(query)}`)).data;
 // }
 async Parentlists(status, query = []) {
  return (await axiosInstanceNew.get(`parents?${status}&${new URLSearchParams(query)}`)).data;
}
async Parentlistss() {
  return (await axiosInstanceNew.get(`parents?limit=10000`)).data;
}
  async ParentlistallData(query = []) {
    return (await axiosInstance.get(`${this.baseUrl}?page=1&size=100`)).data;
  }

  async listbyParentid(data = []) {
    return (
      await axiosInstance.get(`${this.baseUrl}?id=${data}`)
    );
  }
  async listbyParentidStudentGet(data = []) {
    return (
      await axiosInstance.get(`/adminapi/student/?pid=${data}`)
    );
  }
  async listbyParentidStudentSubjectGet(id = []) {
    return (
      await axiosInstance.get(`/adminapi/stsubjects/?id=${id}`)
    );
  }
  async removeParent(data = {}) {
    return await axiosInstance.delete(this.baseUrl, { data: data });
  }

  async createParent(data = []) {
    return await axiosInstance.post(this.baseUrl, data);
  }

  async editParent(data = []) {
    return await axiosInstance.put(this.baseUrl, data);
  }

  async ParentClasslist(id = []) {
    return (
      await axiosInstance.get(`/adminapi/c-class/?parent=${id}`)
      // await axiosInstance.get(`${this.baseUrl}`,{params:data})
    );
  }

  async StudentSubjectList(StudentId) {
    return (
      await axiosInstance.get(`/adminapi/stsubjects/?id=${StudentId}`)
    );
  }
  async AddParentnote(data = []) {
    return await axiosInstanceNew.post(`ParentNotes`, data);
  }
  async getParentnote(id,iid ){
    return await axiosInstanceNew.get(`ParentNotes?ParentId=${id}${iid}`);
  }
  async deleteParentnote(id ){
    return await axiosInstanceNew.delete(`ParentNotes/${id}`);
  }
};

export default new Parentmodel();
